import { Button, ButtonSize, ButtonVariant, DropDownMenu, IconVariants } from "@next-platform/client-common-spicy-ui";

interface ListItem {
  onPress: () => void;
  value: string;
  label: string;
}

interface DropdownProps {
  listItems: ListItem[];
  hasAccessToV2: boolean;
  currentValue: string | null;
  iconEnd: IconVariants;
}

const Dropdown = ({ listItems, currentValue, iconEnd }: DropdownProps) => {
  return (
    <div>
      <DropDownMenu placement="bottom-end" listItems={listItems}>
        <div>
          <Button iconEnd={iconEnd} variant={ButtonVariant.OUTLINED} size={ButtonSize.MEDIUM} aria-label={currentValue}>
            {currentValue}
          </Button>
        </div>
      </DropDownMenu>
    </div>
  );
};

export default Dropdown;
